import { addDoc, collection, collectionGroup, deleteDoc, doc, getDocs, updateDoc } from "@firebase/firestore";
import { db } from "../../../utils/firebase";

// Distinct, case-insensitively-deduped values, sorted. Keeps the first-seen
// casing for display.
function dedupeSorted(values) {
  const seen = new Map();
  values.forEach((raw) => {
    const v = String(raw || '').trim();
    if (!v) return;
    const k = v.toLowerCase();
    if (!seen.has(k)) seen.set(k, v);
  });
  return Array.from(seen.values()).sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
}

// All tags actually used across every recipe (postTags).
export async function getRecipeTagsInUse() {
  const snap = await getDocs(collectionGroup(db, 'posts'));
  const all = [];
  snap.forEach((d) => {
    const pt = d.data().postTags;
    if (Array.isArray(pt)) pt.forEach((t) => all.push(t));
  });
  return dedupeSorted(all);
}

// All units actually used across every recipe (ingredients[].ingredientUnit).
export async function getRecipeUnitsInUse() {
  const snap = await getDocs(collectionGroup(db, 'posts'));
  const all = [];
  snap.forEach((d) => {
    const ings = d.data().ingredients;
    if (Array.isArray(ings)) ings.forEach((i) => all.push(i && i.ingredientUnit));
  });
  return dedupeSorted(all);
}

export async function addUnit(data) {
  const unitRef = collection(db, 'units');
  // append document id to data as unitId
  const docRef = await addDoc(unitRef, data);
  await updateDoc(docRef, { unitId: docRef.id });
  return true;
}

export async function getUnits() {
  const unitRef = collection(db, 'units');
  const unitSnapshot = await getDocs(unitRef);
  const units = [];
  unitSnapshot.forEach((unit) => {
    units.push({ id: unit.id, ...unit.data() });
  });
  return units;
}

export async function deleteUnit(id) {

  console.log("deleteUnit");
  console.log(id);

  const unitRef = doc(db, 'units', id);
  await deleteDoc(unitRef);
  return true;
}

export async function addTag(data) {
  const tagRef = collection(db, 'tags');
  // append document id to data as tagId
  const docRef = await addDoc(tagRef, data);
  await updateDoc(docRef, { tagId: docRef.id });
  return true;
}

export async function getTags() {
  const tagRef = collection(db, 'tags');
  const tagSnapshot = await getDocs(tagRef);
  const tags = [];
  tagSnapshot.forEach((tag) => {
    tags.push({ id: tag.id, ...tag.data() });
  });
  return tags;
}

export async function deleteTag(id) {
  const tagRef = doc(db, 'tags', id);
  await deleteDoc(tagRef);
  return true;
}